import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue } from "firebase/database";

/**
 * ✅ Custom hook to fetch all interview packs for a given domainId
 */
export default function useFetchInterviewPacks(domainId) {
    
    const [packList, setPackList] = useState([]);
    const [loadingPackList, setLoading] = useState(true);

    useEffect(() => {
      
        if (!domainId) { 
            return;
        }

        // 🔸 Reference to the domain’s packs
        const packListRef = ref(db, `Packs/${domainId}`);

        // 🔸 Attach listener for real-time updates
        const unsubscribe = onValue(packListRef, (snapshot) => {
            const data = snapshot.val();

            if (data) {
                const packListArray = Object.entries(data).map(([id, value]) => ({
                    id,
                    ...value,
                }));

                // ✅ Sort by order (optional)
                packListArray.sort((a, b) => (a.order || 0) - (b.order || 0));

                setPackList(packListArray);
            } else {
                setPackList([]);
            }

            setLoading(false);
        });

        // 🔸 Cleanup when component unmounts or domainId changes
        return () => unsubscribe();

    }, [domainId]);

    return { packList, loadingPackList };
}
